import { Component, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-missing-fields',
  templateUrl: './form.missing-fields.component.html',
  standalone: false
})
export class FormMissingFieldsComponent {
  @Input() public fields: { label: string; value?: number }[] = [];

  constructor(private readonly _el: ElementRef) {}

  public focus(): void {
    const alert = this._el.nativeElement.querySelector('[role="alert"]');

    if (alert) {
      alert.focus();
    }
  }
}
